export enum CustomErrorAction {
  SHOW_NOTI = 'SHOW_NOTI',
}

export enum CustomErrorCode {
  CUSTOM_ERROR = 'CUSTOM_ERROR',
}
